import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getAppAction } from "../action/getAppAction";
import { getLocalBankAction } from "../action/getLocalBankAction";

const initialState: CreateAppData = {
  data: {},
  loading: false,
  error: null,
};

const getLocalBankSlice = createSlice({
  name: "getLocalBankSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocalBankAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocalBankAction.fulfilled, (state, action) => {
        // console.log("action payload getApp---> ", action);
        state.loading = false;
        state.data = action.payload.result;
        // console.log("DATA ---> ", action.payload);
      })
      .addCase(getLocalBankAction.rejected, (state, action) => {
        state.loading = false;
        //state.error = action.payload;
      });
  },
});

export const getLocalBankReducer = getLocalBankSlice.reducer;
